/**
 * How long the document has been hidden during boot: from navigation start
 * for a tab already hidden when the bundle evaluated, otherwise from the first
 * `visibilitychange` after that. A hidden tab's timers are throttled and its
 * script may be deferred outright, so its boot timings measure the browser's
 * scheduling rather than the app.
 */
let hiddenAtStart = false;
let hiddenMs = 0;
let hiddenSince: number | null = null;

export function startBootVisibilityTracking() {
  if (typeof document === "undefined") return;
  hiddenAtStart = document.visibilityState === "hidden";
  // Hidden from navigation start, as far as we can tell: nothing observed the
  // tab before this ran.
  hiddenSince = hiddenAtStart ? 0 : null;
  document.addEventListener("visibilitychange", () => {
    const now = performance.now();
    if (document.visibilityState === "hidden") {
      hiddenSince ??= now;
    } else if (hiddenSince !== null) {
      hiddenMs += now - hiddenSince;
      hiddenSince = null;
    }
  });
}

export function bootVisibility() {
  const stillHidden =
    hiddenSince === null ? 0 : performance.now() - hiddenSince;
  return {
    hidden_at_start: hiddenAtStart,
    hidden_ms: Math.round(hiddenMs + stillHidden),
  };
}
